import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer';  
import { getPrincipalMessage } from "../Service/Api"; 
import LazyLoad from 'react-lazyload';
import { useState ,useEffect } from 'react';
const PrincipalMessage = () => {
    useEffect(() => {
        document.title = 'Principal Message -  St Peters convent School Faridabad Haryana';  
    }, []); 
    const [data, setData] = useState([]);
useEffect(() => {
 const fetchData = async () => {
   try {
     const msgdata = await getPrincipalMessage();
    const data = msgdata.filter((item) => item.category === "Principal");
    
     setData(data);
   } catch (error) {
     console.error("Error fetching online registration data:", error);
   }  
 };
 fetchData();
}, []);
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li> 
<li>  About Us  </li> 
     <li> Principal's Message </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1> Principal's Message  </h1>
         </div>
     </div>
     <div className="row">
     {data.length > 0 && (
       <div className="clearfix">
          <LazyLoad> <img 
           src={`https://webapi.entab.info/api/image/${data[0].attachments}`} 
           className="img-fluid col-sm-12 col-md-4 float-md-end mb-3 msgimg" 
           alt={data[0].name || 'Image'}
         /></LazyLoad>
         <p><div dangerouslySetInnerHTML={{ __html: data[0].message }} /></p> 
         <p className="name">
           {data[0].name}<span> {data[0].category} </span>
         </p>
       </div>
     )}

     {data.length === 0  && (
       <div className="clearfix">
          <LazyLoad> <img 
           src="https://webapi.entab.info/api/image/STPSFH/public/Images/dummy.jpg" 
           className="img-fluid col-sm-12 col-md-4 float-md-end mb-3 msgimg" 
           alt=""
         /></LazyLoad>
          <p> Dear Students, </p> 
            <p> I am truly honored to join you as your new Principal. St. Peter’s Convent School is a place of excellence, adorned with multifaceted facilities and well-equipped teachers, shaping thousands of future generations. Facing the challenges of education in the current scenario requires adaptability, resilience, and a commitment to lifelong learning. Rapid technological advancements and changing societal needs demand that we constantly update our skills and knowledge. Embracing digital tools and resources is essential, as they offer new ways to enhance learning and stay connected. </p> 
            <p> At St. Peter’s Convent School, we are equipped with excellent facilities and dedicated teachers to guide and support you. Make use of every opportunity, stay curious, and remain open to new experiences. Together, we can navigate these challenges and continue to thrive. </p> 
            <p> Warm regards, </p>
         <p className="name">
            DR. SR. SHARON THERESE CMC <span>  Principal </span>
         </p>
       </div>
     )}
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default PrincipalMessage
